module.exports = __webpack_public_path__ + "static/img/biaoqing.db92730c.svg";